export const API_ALLLEADS_GET_UNCONVERTED_LIST_SUCCESS =
    "API_ALLLEADS_GET_UNCONVERTED_LIST_SUCCESS";
export const API_ALLLEADS_GET_UNCONVERTED_LIST_FAIL =
    "API_ALLLEADS_GET_UNCONVERTED_LIST_FAIL";
export const GET_ALLLEADS_GET_UNCONVERTED_LIST_OPNED = "GET_ALLLEADS_GET_UNCONVERTED_LIST_OPNED";
export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";